<template>
  <div>
    <div>
      <div class="search-box">
        <div class="tip-box">
          <img
            src="@/assets/images/new_icon_waring_yellow.png"
            style="
              display: inline-block;
              float: left;
              position: absolute;
              width: 14px;
              height: 14px;
              color: #ffffff;
              margin: 14px 4px 0 3px;
            "
          />
          <span style="margin-left: 24px; color: #333"
            >此功能为京东官方功能，必须报备店铺签名后才可以筛选出数据，营销效果分析需要第二天才可以查看！</span
          >
          <span
            :style="{ color: globalBG }"
            style="cursor: pointer"
            @click="toSet"
            >去设置</span
          >
        </div>
        <el-form
          ref="formSearch"
          :inline="true"
          :model="form"
          label-width="120px"
        >
          <el-form-item label="活动主题:">
            <el-input
              size="small"
              v-model="form.activityTitle"
              placeholder="请输入活动主题"
            ></el-input>
          </el-form-item>
          <el-form-item label="短信类型:">
            <el-select size="small" v-model="form.smsType">
              <el-option value="" label="全部" />
              <el-option :value="0" label="普通短信" />
              <el-option :value="1" label="富信" />
              <el-option :value="2" label="卡片短信" />
            </el-select>
          </el-form-item>
          <el-form-item label="短信内容:">
            <el-input
              size="small"
              v-model="form.content"
              placeholder="请输入短信内容"
            ></el-input>
          </el-form-item>
          <el-form-item label="发送时间:">
            <div class="my_select_time">
              <el-date-picker
                prefix-icon="no_icon"
                v-model="form.sendStartTime"
                type="datetime"
                :placeholder="'选择日期时间'"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 120px; font-size: 12px"
                class="time1"
                :clearable="false"
              ></el-date-picker>
              <div class="time_to_text" style="margin-top: 1px !important">
                至
              </div>
              <el-date-picker
                prefix-icon="no_icon"
                v-model="form.sendEndTime"
                type="datetime"
                :placeholder="'选择日期时间'"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 145px; font-size: 12px"
                class="time2"
                :clearable="false"
              ></el-date-picker>
              <i
                class="el-icon-circle-close date_icon1"
                @click="clearTimeSendTime()"
              ></i>
              <img
                src="@/assets/images/select_date.svg"
                alt
                class="date_icon2"
              />
            </div>
          </el-form-item>
        </el-form>
        <div class="el_btn">
          <el-button
            size="small"
            :disabled="tableLoding"
            class="search"
            @click="
              form.current = 1;
              submitForm('formSearch');
            "
          >
            <i
              class="el-icon-search"
              style="display: inline-block; width: 14px; height: 12px"
            ></i>
            查询
          </el-button>
          <el-button size="small" class="reset" @click="resetForm"
            >重置</el-button
          >
        </div>
      </div>
      <div class="table-box">
        <div class="batchUpload">
          <el-button class="status_btn3" @click="staVisible = true">批量下载</el-button>
        </div>
        <div style="color: #fe4d45; padding-bottom: 5px;">
          注意：短信扣费先按照提交条数预扣相应短信条数，余额会减少，发送后4~7天会按照京东实际返回的短信状态报告成功扣费，短信条数多退少补。
        </div>
        <el-table
          ref="table"
          :data="tableData"
          v-loading="tableLoding"
          tooltip-effect="light"
          style="width: 100%; border: 1px solid #eee"
        >
          <el-table-column
            label="序号"
            type="index"
            width="80px"
          ></el-table-column>
          <el-table-column label="短信类型" width="80px">
            <template slot-scope="scope">
              <span v-if="scope.row.smsType == 0">普通短信</span>
              <span v-else-if="scope.row.smsType == 1">富信</span>
              <span v-else-if="scope.row.smsType == 2">卡片短信</span>
            </template>
          </el-table-column>
          <el-table-column
            label="活动主题"
            prop="activityTitle"
          ></el-table-column>
 
        <el-table-column
            key="content"
            label="短信内容"
            min-width="400px"
            prop="content"
            width="400"
          >
            <template slot="header" slot-scope="scope">
              <span>短信内容</span>
              <span
                v-if="!allShow"
                :style="{ color: globalBG }"
                @click="allShow = true"
                class="table-message"
                >(展开全部)</span
              >
              <span
                v-if="allShow"
                :style="{ color: globalBG }"
                @click="allShow = false"
                class="table-message"
                >(单行显示)</span
              >
            </template>
            <template slot-scope="scope">
              <div>
                <el-tooltip
                class="item"
                effect="light"
                :content="scope.row.mediaTitle"
                placement="top"
                 v-if="scope.row.smsType == 1"
                >
                  <div class="hoveTitle" v-show="!allShow" style="color: #9485ed;cursor: pointer;" @click="showMediaInfo(scope.row)">
                    {{ scope.row.mediaTitle }}
                  </div>
                </el-tooltip>
                <el-tooltip
                class="item"
                effect="light"
                :content="scope.row.content"
                placement="top"
                 v-else-if="scope.row.smsType == 2"
                >
                  <div class="hoveTitle" v-show="!allShow" style="color: #9485ed;cursor: pointer;" @click="showCardInfo(scope.row)">
                    {{ scope.row.mediaTitle }}
                  </div>
                </el-tooltip>
                <el-tooltip
                  class="item"
                  effect="light"
                  :content="scope.row.content"
                  placement="top"
                  v-else
                >
                  <div class="hoveTitle" v-show="!allShow">
                    {{ scope.row.content }}
                  </div>
                </el-tooltip>
                <div class="hoveTitleShowMore" v-show="allShow"  v-if="scope.row.smsType == 1" style="color: #9485ed;cursor: pointer;"  @click="showMediaInfo(scope.row)"> 
                  {{ scope.row.mediaTitle }}
                </div>
                <div class="hoveTitleShowMore" v-show="allShow" v-else-if="scope.row.smsType == 2" @click="showCardInfo(scope.row)">
                  {{ scope.row.mediaTitle }}
                </div>
                <div class="hoveTitleShowMore" v-show="allShow" v-else>
                  {{ scope.row.content }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column key="selectedCrowd" width="400" label="活动对象">
          <template slot="header" slot-scope="scope">
            <span>活动对象</span>
            <span
              v-if="!allShowCrowd"
              :style="{ color: globalBG }"
              @click="allShowCrowd = true"
              class="table-message"
              >(展开全部)</span
            >
            <span
              v-if="allShowCrowd"
              :style="{ color: globalBG }"
              @click="allShowCrowd = false"
              class="table-message"
              >(单行显示)</span
            >
          </template>
        <template slot-scope="scope" v-if="scope.row.activeObject">
            <div>
              <el-tooltip
                class="item"
                effect="light"
                :content="scope.row.activeObject"
                placement="top"
              >
                <div class="hoveTitle" v-show="!allShowCrowd">
                  {{ scope.row.activeObject}}
                </div>
              </el-tooltip>
              <div class="hoveTitleShowMore" v-show="allShowCrowd">
                {{ scope.row.activeObject }}
              </div>
            </div>
          </template>
        </el-table-column>
          <el-table-column
            label="发送时间"
            key="sendTime"
            prop="sendTime"
          ></el-table-column>
          <el-table-column
            label="营销成本"
            key="marketingCosts"
            prop="marketingCosts"
          > 
            <template slot="header" slot-scope="scope">
              <span>营销成本</span>
              <el-tooltip effect="dark" placement="top">
                <div slot="content">营销成本=短信成功扣费条数*短信单价<br/>普通短信：0.05元，富信：0.42元，卡片短信0.38元</div>
                <i class="el-icon-question" style="margin-left: 4px;"></i>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <div>{{ scope.row.marketingCosts }}</div>
            </template>
          </el-table-column>
          <el-table-column
            label="实际触达人数"
            key="sendNum"
            prop="sendNum"
          ></el-table-column>
          <el-table-column label="操作" width="160">
            <template slot-scope="scope">
              <el-button
                type="text"
                style="width: 60px"
                class="operation"
                @click="handeleEffect(scope.row)"
                >效果分析</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页器 -->
        <div>
          <el-pagination
            background
            style="text-align: right; margin-top: 20px"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="form.current"
            :page-sizes="[10, 20, 30, 50, 100, 500]"
            :page-size="form.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="crowdTotal"
          ></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog title="统计时间" width="650px" :visible.sync="staVisible">
      <template slot="title">
        <span style="font-size: 16px; color: #333333; font-weight: bold; margin-right: 6px;">统计时间</span> 
        <el-popover
          placement="right"
          width="400"
          trigger="hover"
        >
          营销效果从发送后第二天开始统计，最多统计发送后30天的数据，每天0点更新数据，所有数据由京东提供
          <i class="el-icon-question" slot="reference" style="color: #aaaaaa;"></i>
        </el-popover>
      </template>
      <el-form>
        <el-form-item label="效果数据时间">
          <el-select style="width: 100px;" v-model="staValue" @change="staValueChange">
            <el-option
              v-for="(item, index) in statiType"
              :key="index"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <template v-if="staValue == ''">
            <el-select style="margin: 0 10px; width: 110px;" v-model="timeType">
              <el-option label="相对时间" :value="1"></el-option>
              <el-option label="绝对时间" :value="2"></el-option>
            </el-select>
            <el-input
              style="width: 160px;"
              v-model="customValue"
              @keyup.native="customValue = limitInput($event)"
              v-if="timeType == 1"
            >
              <template slot="suffix"> 天 </template>
            </el-input>
            <div class="my_select_time" v-else>
              <el-date-picker
                prefix-icon="no_icon"
                v-model="startTime"
                type="datetime"
                :placeholder="'开始时间'"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 120px; font-size: 12px"
                class="time1"
                :clearable="false"
                :picker-options="startTimeOption"
              ></el-date-picker>
              <div class="time_to_text" style="margin-top: 1px !important">
                至
              </div>
              <el-date-picker
                prefix-icon="no_icon"
                v-model="endTime"
                type="datetime"
                :placeholder="'结束时间'"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 145px; font-size: 12px"
                class="time2"
                :clearable="false"
                :picker-options="endTimeOption"
                default-time="23:59:59"
              ></el-date-picker>
              <i
                class="el-icon-circle-close date_icon1"
                @click="clearEffectTime()"
              ></i>
              <img
                src="@/assets/images/select_date.svg"
                alt
                class="date_icon2"
              />
            </div>
          </template>
        </el-form-item>
        <el-form-item label="添加备注" style="margin-left:18px">
          <el-input
            show-word-limit
            maxlength="20"
            type="textarea"
            :rows="3"
            style="width:220px; margin-left: 10px"
            v-model="customValue1"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <div class="footer">
        <button class="cancel" @click="staVisible = false">取消</button>
        <button class="confirm" @click="batchUpload">确定</button>
      </div>
    </el-dialog>
    <!-- 富信模板 -->
    <sms-info 
      v-if="smsInfoShow" 
      @close="smsInfoShow = false" 
      :isShow="smsInfoShow" 
      :id="smsInfoId"
      :title="smsInfoTitle"
      :text="smsInfoText"
    />
    <sms-info-card v-if="smsInfoCardShow" :isShow="smsInfoCardShow" @close="smsInfoCardShow = false" :id="cardId"></sms-info-card>
    <!-- 生成报表 -->
    <generate :control = 'control' 
              v-if="control"
               @transData="(val) => (control = val)"
               @transData1 = 'getphone1'
               :flags= 'flags'
               ></generate>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { getSmsRecordPage,intelligentExport } from "@/api/intelligentMarket/index";
import generate from '../../components/generate_report.vue'
import smsInfo from '@/components/sms-info'
import smsInfoCard from '@/components/sms-info-card'
export default {
  components: {
    smsInfo,
    generate,
    smsInfoCard
  },
  props:{
    searchform:{
      type: Object,
    }
  },
  name: "",
  data() {
    return {
      cardId:null,
      smsInfoCardShow:false,
      timeType: 1,
      customValue1:'',
      flags:0,
      customValue1:'',
      control:false,
      staVisible: false,
      staValue: "7",
      customValue: '',
      startTime: "", // 统计开始时间
      endTime: "", // 统计结束时间
      startTimeOption: {
        disabledDate: (date) => {
          let endTime = this.endTime;
          let time = date.getTime();
          let isDisabled = false;
          if (endTime) {
            isDisabled = time + 24 * 60 * 60 * 1000 >= new Date(endTime).getTime();
          }
          return isDisabled;
        },
      },
      endTimeOption: {
        disabledDate: (date) => {
          let startTime = this.startTime;
          let time = date.getTime();
          let isDisabled = false;
          if (startTime) {
            isDisabled = time <= new Date(startTime).getTime() - 24 * 60 * 60 * 1000;
          }
          return isDisabled;
        },
      },
      statiType: [
        {
          label: "近7天",
          value: "7",
        },
        {
          label: "近15天",
          value: "15",
        },
        {
          label: "近30天",
          value: "30",
        },
        {
          label: "自定义",
          value: "",
        },
      ],
      form: {
        size: 10,
        current: 1,
        activityTitle: "",
        content: "",
        sendStatus: 101,
        sendStartTime: "",
        sendEndTime: "",
        smsType: "",
      },
      allShow: false,
      allShowCrowd: false,
      sendStatusList: [
        {
          label: "待审核",
          value: 1,
        },
        {
          label: "待发送",
          value: 3,
        },
        {
          label: "审核未通过",
          value: 4,
        },
        {
          label: "已取消",
          value: 5,
        },
        {
          label: "发送中",
          value: 100,
        },
        {
          label: "已发送",
          value: 101,
        },
        {
          label: "发送失败",
          value: 102,
        },
      ],
      tableData: [],
      tableLoding: false,
      crowdTotal: 0,
            mytimestart:"",
      mytimeend:"",
      smsInfoShow: false, // 富信
      smsInfoId: "", // 富信id
      smsInfoTitle: "", // 富信标题
      smsInfoText: "", // 富信内容
    };
  },
  computed: {
    ...mapState({
      globalBG: "globalBG",
    }),
  },

  watch: {
    timeType(nVal) {
      if (nVal == 1) {
        this.clearEffectTime()
      } else {
        this.customValue = ""
      }
    }
  },

  mounted() {
    this.time();
    if(this.searchform){
      this.form.activityTitle = this.searchform.activityName
      this.form.marketingId = this.searchform.id
      this.form.sendStartTime=''
      this.form.sendEndTime=''
      this.form.current = 1;
      this.clearTime1()
      this.submitForm('formSearch')
    }else{
      this.form.marketingId = ''
      this.queryList();
    }
  },
  methods: {
    staValueChange(val) {
      if (val) {
        this.customValue = ""
        this.clearEffectTime()
      }
    },

    // 清除效果数据时间
    clearEffectTime() {
      this.startTime = ""
      this.endTime = ""
    },
    showMediaInfo(row) {
      this.smsInfoShow = true
      this.smsInfoId = row.mediaMulitiFileId
      this.smsInfoTitle = row.mediaTitle
      this.smsInfoText = row.content
    },
    showCardInfo(row){
      this.cardId = row.mediaTemplateId;
      this.smsInfoCardShow = true;
    },
     limitInput(event) {
      var value = event.target.value;
      if (value == '0') {
        event.target.value = ''
      } else if (value >= 30) {
        event.target.value = 30
      } else {
        event.target.value = value.replace(/[^\d]/g, '')
      }
      return event.target.value
    },
     time() {
      let yy = new Date().getFullYear(); //当前年份
      let mm =
        new Date().getMonth() + 1 < 10
          ? "0" + (new Date().getMonth() + 1)
          : new Date().getMonth() + 1;
      let dd =
        new Date().getDate() < 10
          ? "0" + new Date().getDate()
          : new Date().getDate(); //当前天数
      this.mytimestart = this.getDateStr(-30) + " 00:00:00";
      this.mytimeend = `${yy}-${mm}-${dd} 23:59:59`;
      this.form.sendStartTime = this.mytimestart;
      this.form.sendEndTime = this.mytimeend;
    },
     //批量下载
    batchUpload() {
      var dayNum = this.staValue;
      if (this.staValue === '') {
        dayNum = this.customValue;
        if(this.customValue>=30){
          dayNum = 30
        }
        if (!dayNum && this.timeType == 1) {
          this.$message.warning('请输入天数！')
          return;
        }
        if (this.timeType == 2 && !this.startTime) {
          this.$message.warning("请选择开始时间！");
          return;
        }
        if (this.timeType == 2 && !this.endTime) {
          this.$message.warning("请选择结束时间！");
          return;
        }
      }
      let param = {
        activityTitle: this.form.activityTitle,
        content: this.form.content,
        smsType:this.form.smsType,
        dayNum: dayNum,
        source: 3,
        exportRemark:this.customValue1,
        startTime: this.startTime,
        endTime: this.endTime,
      };

      if (this.form.sendStartTime) {
        param.sendTimeStart = this.form.sendStartTime;
      }
      if (this.form.sendEndTime) {
        param.sendTimeEnd = this.form.sendEndTime;
      }
      let paramStr = "";
      for (var key in param) {
        let temp = "&" + key + "=" + param[key];
        paramStr += temp;
      }
      paramStr = paramStr.substr(1);
      intelligentExport(param).then((res)=>{
        if(res.code==1){
          this.staVisible = false;
          this.control = true
          this.flags = 1
        }else{
          this.$message.error(res.data.message);
        }
      })
    },
    queryList() {
      this.tableLoding = true;
      getSmsRecordPage(this.form).then((res) => {
        this.tableLoding = false;
        if (res.code == "1") {
          this.tableData = res.data.records;
          this.crowdTotal = res.data.total;
        }
      });
    },

    handeleEffect(row) {
      this.officialObj = {
        outerId: row.id,
        source: "INTELLIGENT_MARKETING",
        sendTime: row.sendTime,
      };
      this.$emit("showEffect", this.officialObj);

      // 跳转到新标签页
      let routeUrl =this.$router.resolve({
          path: "/marketing/marketing/intelligent_market",
          query: {
            outerId: row.id,
            source: "INTELLIGENT_MARKETING",
            sendTime: row.sendTime,
          },
        });
        window.open(routeUrl.href, "_blank");
    },
    handleSizeChange(val) {
      this.form.size = val;
      this.submitForm();
    },
    handleCurrentChange(val) {
      this.form.current = val;
      this.submitForm();
    },

    submitForm(name) {
      this.queryList();
    },
    resetForm() {
      this.searchform=''
      this.form = {
        size: 10,
        current: 1,
        activityTitle: "",
        content: "",
        sendStatus: 101,
        sendStartTime: "",
        sendEndTime: "",
        marketingId:"",
      };
      this.queryList();
    },
    // 精准营销的取消发送
    handleCancelPrecision(row, index) {
      this.$confirm("确定要取消吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        iconClass: "iconfont iconicon-jinggao1",
      }).then(() => {
        var param = {
          sendTime: row.sendTime,
          activityRecordId: row.activityRecordId,
        };
        cancelSendSms(param).then((res) => {
          if (res.code == "1") {
            this.$message.success("取消发送成功");
            this.submitForm();
          } else {
            this.$message.error(res.message);
          }
        });
      });
    },

    toSet() {
      let routeUrl = this.$router.resolve({
        path: "/backstage/signature_management/signature_report_official",
      });
      window.open(routeUrl.href, "_blank");
    },
    clearTime1() {
      this.form.submitTimeStart = "";
      this.form.submitTimeEnd = "";
    },
    clearTimeSendTime() {
      this.form.sendStartTime = "";
      this.form.sendEndTime = "";
    },
  },
};
</script>

<style scoped lang="scss">
/deep/ .el-dialog__body{
  padding-bottom: 20px!important;
}
/deep/ .el-table th.is-leaf {
  height: 50px;
}
 .batchUpload {
    padding-bottom: 10px;
    .status_btn3 {
      width: 98px;
      padding: 5px 12px;
      height: 32px;
      color: #ffffff;
      border-radius: 3px;
      border: 1px solid #fe4d45;
      background-color: #fe4d45;
      &:hover {
        color: #fff;
        opacity: 0.9;
        background-color: #fe4d45;
      }
      &:active {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }
    }
  }
.footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 20px;
  .cancel,
  .confirm {
    width: 98px;
    font-size: 14px;
    height: 32px;
  }
  .cancel {
    margin-right: 8px;
    color: #999999;
    border: 1px solid #cccccc;
    background-color: #fff;
    &:hover {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
  }
  .confirm {
    color: #ffffff;
    background-color: #fe4d45;
    &:hover {
      color: #fff;
      opacity: 0.9;
      background-color: #fe4d45;
    }
  }
}
/** 表单搜索  */
.search-box {
  margin-top: 20px;
  padding-bottom: 20px;
  .el_btn {
    text-align: center;
    .search {
      width: 98px;
      height: 32px;
      font-size: 14px;
      border-radius: 3px;
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff;
      &:hover {
        color: #fff;
        border: 1px solid #fff;
        background-color: #fe4d45;
      }
    }
    .reset {
      width: 98px;
      height: 32px;
      font-size: 14px;
      border-radius: 3px;
      color: #666666;
      border: 1px solid #dddddd;
      background-color: #fff;
      &:hover {
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff4f4;
      }
    }
  }
  .el-input,
  .el-select {
    width: 280px;
  }
  .my_select_time {
    display: flex;
    align-items: center;
  }
}
/** 表格内容 */
.table-box {
  // margin: 20px;
  margin-top: 20px;
  padding: 0 28px 24px 28px;
  .control-button {
    .el-button {
      width: 65px;
      margin-left: 0 !important;
    }
    
  }
}
.operation {
      cursor: pointer;
      color: #7f85e9;
      &:hover {
        color: #fe4d45;
      }
    }
.question_icon {
  width: 14px;
  height: 14px;
  color: #7f85e9 !important;
  display: inline-block;
  line-height: 12px !important;
  text-align: center;
  border-radius: 14px;
  border: 1px solid #7f85e9;
  font-size: 12px !important;
  font-weight: normal !important;
  margin-left: 8px;
  &:hover {
    color: #fe4d45 !important;
    border: 1px solid #fe4d45;
  }
}
/* 短信记录/效果分析  */
.tip-box {
  padding-left: 24px;
  text-align: left;
  line-height: 21px;
  font-size: 14px;
  margin-top: 12px;
  color: #999999;
  background: #fffaee;
  position: relative;
  margin: 20px 28px 20px 28px;
  line-height: 42px;
  .warning-icon {
    color: #fe8f8a;
    font-size: 14px;
    position: absolute;
    left: 5px;
    top: 13px;
  }
}
.table-message {
  color: #7f85e9 !important;
  cursor: pointer;
}
</style>